import React from "react"
import {Typography} from "@mui/material"

interface FieldLabelProps {
  textColor: string
  children: React.ReactNode
}

export default function FieldLabel({textColor, children}: FieldLabelProps) {
  return (
    <Typography sx={{mb: 0.5, fontWeight: 500, textAlign: "left", color: textColor}}>
      {children}
    </Typography>
  )
}
